import { h, Component, Element, Event, EventEmitter, Prop }
  from '@stencil/core';
import { KeywordFilter } from '../root/keyword-filter';


@Component({
  tag: 'tip-search-box'
})
export class SearchBox {
  @Element() el: HTMLElement;

  @Event() glFilterChanged: EventEmitter
  @Prop() tableId: string;
  @Prop({ mutable: true}) value: string;
  @Prop({ mutable: true}) keywordFilter: KeywordFilter;

  handleChange(_e) {
    this.value = this.el.querySelector('ion-searchbar').value;
    this.keywordFilter = new KeywordFilter({value: this.value})
    this.glFilterChanged.emit()
  }

  render() {
    return (
      <ion-searchbar placeholder="Filter by keyword"
                     onIonInput={ (_e) => this.handleChange(_e) }
                     showCancelButton={true}
                     value={this.value}>
      </ion-searchbar>
    );
  }
}
